
































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import _ from "lodash";
import moment from "moment";
import MyList from "@/mixins/list";

import Add from "./groundlights_task_add.vue";
import Edit from "./groundlights_task_edit.vue";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  @Prop() equipmentSubId!: number;

  dispatchType: string = "equipment/task";
  dispatchTypeDelete: string = "equipment/taskdelete";
  deleteConfirmContent: string = "你确定要删除该记录？";

  columns: any[] = [
    {
      title: "编号",
      dataIndex: "id"
    },
    { title: "类型", scopedSlots: { customRender: "time_type" } },
    { title: "星期", scopedSlots: { customRender: "week_days" } },
    { title: "开灯时间", scopedSlots: { customRender: "open_time_clock" } },
    { title: "关灯时间", scopedSlots: { customRender: "close_time_clock" } },
    { title: "是否启用", scopedSlots: { customRender: "status" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  renderWeek(week_days: number) {
    let str: string = "";
    for (const week of this.weeks) {
      if (((1 << Number(week.key)) & week_days) > 0) {
        str += week.name + " ";
      }
    }
    return str;
  }

  hideAddModal1() {
    this.addModalVisible = false;
    this.loadData1();
  }

  hideEditModal1() {
    this.editModalVisible = false;
    this.loadData1();
  }

  handleDelete1(id: number, params?: any) {
    if (_.has(params, ["permKey"])) {
      if (!this.checkPermission(params.permKey)) {
        this.$message.error("没有权限");
        return;
      }
    }
    this.$confirm({
      title: this.deleteConfirmTitle,
      content: this.deleteConfirmContent,
      onOk: async () => {
        const res = await this.$store.dispatch(this.dispatchTypeDelete, {
          id,
          ...params
        });
        if (res && res.Message === "success") {
          this.$message.success(res.Message);
          this.loadData1();
        } else {
          this.$message.error(res.Message);
        }
      },
      onCancel() {
        // alert('cancel')
      }
    });
  }

  async loadData1() {
    this.loading = true;
    const res = await this.$store.dispatch(this.dispatchType, {
      equipment_sub_id: this.equipmentSubId
    });

    this.data = res.Data;

    this.loading = false;
  }

  renderHour(h: any, m: any) {
    return moment({ h: h, m: m }).format("HH:mm");
  }

  mounted() {
    this.loadData1();
  }
}
